const actionTypes = {
  RECEIVE_SCHOOL_INFO: "seneca/schoolInfo/RECEIVE_SCHOOL_INFO"
};

export default actionTypes;
